"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var Colors_1 = require("./components/atoms/Styles/Colors/Colors");
exports.theme = {
    colors: __assign({}, Colors_1.Colors),
    fonts: {
        body: '"MuseoSans", "Arial", sans-serif',
        heading: '"cinzel", "Times", "Times New Roman", serif'
    },
    fontWeights: {
        body: 400,
        heading: 700,
        bold: 700
    },
    lineHeights: {
        body: 1.6,
        heading: 1.125
    },
    fontSizes: ["1.4rem", "1.6rem", "1.8rem", "2rem", "2.4rem", "3rem", "4rem", ".875rem"],
    space: ["1rem", "2rem", "3rem", "4rem", "5rem"],
    buttons: {
        primary: {
            color: "background",
            bg: "primary",
            background: "linear-gradient(-180deg, #e6b226 0%, #D87B19 100%)",
            borderRadius: 0,
            p: "0.5em 0.8em",
            lineHeight: 1,
            cursor: "pointer",
            textAlign: "center",
            fontFamily: "heading",
            fontWeight: "bold",
            textTransform: "uppercase",
            textShadow: "0 0.0625rem 0.0625rem rgba(236,237,238,0.75)",
            borderBottom: ".1875rem solid #9f4000",
            borderLeft: ".1875rem solid #f0d079",
            borderRight: ".1875rem solid #9f4000",
            borderTop: ".1875rem solid #f0d079",
            boxShadow: "0.1875rem 0.1875rem 0.1875rem 0.0625rem",
            transition: "filter 0.25s ease-out,background-color 0.25s ease-out,color 0.25s ease-out,border 0.25s ease-out,-webkit-filter 0.25s ease-out",
            ":hover": {
                filter: "brightness(1.3)"
            },
            ":active, :focus": {
                filter: "brightness(0.95)",
                textDecoration: "none",
                boxShadow: "none",
                transition: "none",
                borderTop: ".1875rem solid #9f4000",
                borderRight: ".1875rem solid #f0d079",
                borderLeft: ".1875rem solid #9f4000",
                borderBottom: ".1875rem solid #f0d079"
            },
            ":disabled": {
                filter: "grayscale(1)",
                cursor: "not-allowed"
            }
        },
        secondary: {
            variant: "buttons.primary",
            color: "primary",
            background: "none",
            bg: "none",
            border: "1px solid #E1BB34",
            boxShadow: "none",
            textShadow: "0 0.0625rem 0.0625rem rgba(7,24,32,0.75)",
            ":active, :focus": {
                filter: "brightness(1.3)",
                boxShadow: "none",
                textShadow: "0 0.0625rem 0.0625rem rgba(7,24,32,0.75)",
                transition: "none",
                borderTop: ".1875rem solid #9f4000",
                borderRight: ".1875rem solid #f0d079",
                borderLeft: ".1875rem solid #9f4000",
                borderBottom: ".1875rem solid #f0d079"
            }
        }
    },
    text: {
        default: {
            lineHeight: "body",
            textRendering: "optimizeLegibility"
        },
        heading: {
            textTransform: "uppercase",
            py: "10px"
        },
        h1: {
            variant: "text.heading",
            color: "primary",
            fontSize: "1.5rem"
        },
        h2: {
            variant: "text.heading",
            fontSize: "1.25rem"
        },
        h3: {
            variant: "text.heading"
        },
        caption: {
            fontSize: 7
        }
    },
    loaders: {
        small: {
            size: 40,
            color: "heading"
        },
        medium: {
            size: 48,
            color: "heading"
        }
    },
    styles: {
        root: {
            fontFamily: "body"
        },
        h1: {
            variant: "text.h1"
        },
        h2: {
            variant: "text.h2"
        },
        h3: {
            variant: "text.h3"
        },
        caption: {
            variant: "text.caption"
        }
    }
};
